/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PatientRoomCheckAliases {
  AGE_FIELD = 'age-field',
  AGE_PANEL = 'age-panel',
  AGE_TEXT = 'age-text',
  BARCODE_PANEL = 'barcode-panel',
  BASIC_UNIT_FIELD = 'basic-unit-field',
  BASIC_UNIT_PANEL = 'basic-unit-panel',
  BASIC_UNIT_TEXT = 'basic-unit-text',
  BIRTH_DATE_TEXT = 'birthDate-text',
  BIRTHDATE_PANEL = 'birthdate-panel',
  BITH_DATE_FIELD = 'bithDate-field',
  BODY_CARD_CONTAINER_ZONE = 'body-card-container-zone',
  CARD_CONTAINER = 'card-container',
  CARD_CONTAINER_BODY = 'card-container-body',
  HEADER_CONTEXTUAL_BAR = 'header-contextual-bar',
  PATIENT_NAME_FIELD = 'patient-name-field',
  PATIENT_NAME_PANEL = 'patient-name-panel',
  PATIENT_NAME_TEXT = 'patient-name-text',
  PATIENT_ROOM_CHECK_BARCODE = 'patient-room-check-barcode',
  PATIENT_ROOM_CHECK_CARD_PANEL = 'patient-room-check-card-panel',
  PATIENT_ROOM_CHECK_LAYOUT = 'patient-room-check-layout',
  PATIENT_ROOM_CHECK_MAPPER = 'patient-room-check-mapper',
  PATIENT_ROOM_CHECK_PANEL = 'patient-room-check-panel',
  PROCEDURE_FIELD = 'procedure-field',
  PROCEDURE_PANEL = 'procedure-panel',
  PROCEDURE_TEXT = 'procedure-text',
  ROOM_FIELD = 'room-field',
  ROOM_PANEL = 'room-panel',
  ROOM_TEXT = 'room-text',
  SUPPLEMENTARY_UNIT_FIELD = 'supplementary-unit-field',
  SUPPLEMENTARY_UNIT_PANEL = 'supplementary-unit-panel',
  SUPPLEMENTARY_UNIT_TEXT = 'supplementary-unit-text',
  SURGEON_FIELD = 'surgeon-field',
  SURGEON_PANEL = 'surgeon-panel',
  SURGEON_TEXT = 'surgeon-text',
}
export { PatientRoomCheckAliases };
